module.exports = __webpack_public_path__ + "static/media/unauthorizedVC.9ee46dd6.svg";